<template>
  <rich-suggestion
    ref="suggestion"
    :editor="editor"
    :lookup-function="findMatches"
    plugin-name="suggestion-image"
    matcher-char="$"
    mention-class="badge badge-image"
    mention-type="thumbnail"
    icon-class="fa-eye"
  >
    <template #default="{ item }"> ${{ item.label }} </template>
  </rich-suggestion>
</template>

<script>
  import RichSuggestion from '@/Atoms/RichSuggestion';
  import { CaseResource } from '@/api-resources';

  export default {
    name: 'RichSuggestionImage',

    components: {
      RichSuggestion,
    },

    props: {
      editor: null,
      relatedCase: CaseResource,
      images: Array,
    },

    computed: {
      plugin() {
        return this.$refs.suggestion.plugin;
      },
    },

    methods: {
      findMatches(query) {
        return Promise.resolve(this.images).then((thumbnails) => {
          const result = [];

          thumbnails &&
            thumbnails.forEach((thumbnail) => {
              result.push({ ...thumbnail, label: thumbnail.reference });

              thumbnail.hasAnnotations &&
                thumbnail.annotations.forEach((annotation) => {
                  result.push({ ...thumbnail, label: annotation.label });
                });
            });

          return result
            .filter(({ label }) => label.indexOf(query) === 0)
            .sort((a, b) => (a.label < b.label ? -1 : a.label > b.label ? 1 : 0))
            .slice(0, 10);
        });
      },
    },
  };
</script>

<style scoped></style>
